module.exports = __webpack_public_path__ + "img/share.2b43d51a.svg";